import React from "react";
import { ExternalLink, Vote, Gift, Clock } from "lucide-react";
import { toast } from "sonner";
import { useContentList, useContentObject } from "../hooks/useContentData";
import { contentFallback } from "../contentDefaults";

const STAT_ICONS = [Vote, Gift, Clock];

const VoteSection = () => {
  const { data: header } = useContentObject("home.votes_header", contentFallback("home.votes_header"));
  const { items: stats } = useContentList("home.votes_stats", contentFallback("home.votes_stats"));
  const { items: sites } = useContentList("home.votes_sites", contentFallback("home.votes_sites"));

  const handleVote = (site) => {
    if (site.url && site.url !== "#") {
      window.open(site.url, "_blank", "noopener");
    }
    toast.success(`Redirigiendo a ${site.name}`, {
      description: `Recompensa: ${site.reward} · Cooldown: ${site.cooldown}`,
    });
  };

  return (
    <section className="relative py-28 bg-[#0a0a0d] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0a0d] via-[#111118]/40 to-[#0a0a0d]" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="ornament"><span>{header?.eyebrow || "Vota & Recibe"}</span></div>
            <h2 className="section-title mt-6">{header?.title || "Apoya el Reino"}</h2>
            <div className="gold-divider w-32 mt-6" />
            <p className="mt-6 text-[#b8b3a8] leading-relaxed">{header?.description || ""}</p>
            <div className="mt-8 grid grid-cols-3 gap-4">
              {stats.map((s, i) => {
                const Icon = STAT_ICONS[i] || Vote;
                return (
                  <div key={i} className="glass rounded-sm p-4 text-center">
                    <Icon className="w-5 h-5 text-[#d4a843] mx-auto mb-2" />
                    <div className="font-display font-bold text-[#f0ebe0]">{s.label}</div>
                    <div className="text-[10px] uppercase tracking-[0.2em] text-[#8a8a92] mt-1">{s.sub}</div>
                  </div>
                );
              })}
            </div>
          </div>

          <div className="flex flex-col gap-3">
            {sites.map((site) => (
              <button
                key={site.id ?? site.name}
                type="button"
                onClick={() => handleVote(site)}
                className="group glass rounded-sm p-5 flex items-center gap-5 text-left hover:translate-x-1 transition-all"
              >
                <div className="w-14 h-14 rounded-sm bg-gradient-to-br from-[#f5c542] via-[#d4a843] to-[#8b6914] flex items-center justify-center font-display font-extrabold text-2xl text-[#1a1408] shrink-0">
                  {site.logo}
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="font-display font-bold text-base text-[#f0ebe0] group-hover:text-[#f5c542] transition-colors">
                    {site.name}
                  </h4>
                  <div className="flex items-center gap-3 mt-1">
                    <span className="font-mono text-xs text-[#10b981]">+{site.reward}</span>
                    <span className="text-[10px] text-[#6f6c66]">|</span>
                    <span className="font-mono text-xs text-[#8a8a92]">{site.cooldown}</span>
                  </div>
                </div>
                <ExternalLink className="w-4 h-4 text-[#8a8a92] group-hover:text-[#d4a843]" />
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default VoteSection;
